export function foreachReverse(arr, action, getter, context) {
  if (context === void 0) {
    context = {};
  }
  for (var i = arr.length - 1; i >= 0; i--) {
    action.call(context, getter(arr, i));
  }
}